export const whiteElephantSounds = {
    UIAddPerson: { src: '/audio/white-elephant/ui_add_person.mp3' },
    UIAllPeople_success: { src: '/audio/white-elephant/ui_all_people_success.mp3' },

    CardAppear: { src: '/audio/white-elephant/anim_card_appear.mp3' },
    CardLeave: { src: '/audio/white-elephant/anim_card_leave.mp3' },
    CardsZoom_in: { src: '/audio/white-elephant/anim_cards_zoom_IN.mp3' },
    CardsZoom_out: { src: '/audio/white-elephant/anim_cards_zoom_OUT.mp3' },
    GameComplete: { src: '/audio/white-elephant/anim_game_complete.mp3' },

    Steal_or_rip: { src: '/audio/white-elephant/anim_STEAL_or_RIP.mp3' },
    Steal: { src: '/audio/white-elephant/anim_STEAL.mp3' },
    BGTitleInOut: { src: '/audio/white-elephant/bg_title_IN_OUT.mp3' },

    UIIntro: { src: '/audio/white-elephant/ui_intro.mp3' },
    UINamesIN: { src: '/audio/white-elephant/ui_names_IN.mp3' },
    UIOutro: { src: '/audio/white-elephant/ui_outro.mp3' },
    UIPeopleBounce: { src: '/audio/white-elephant/ui_people_bounce.mp3' },
    UIPeopleLeave: { src: '/audio/white-elephant/ui_people_leave.mp3' },
};
